var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { fetchVideos } from "./api/fetch";
import VideosList from './components/videos/list.vue';
import GamesFilter from './components/root/games.vue';
window.addEventListener('DOMContentLoaded', function (e) { return __awaiter(void 0, void 0, void 0, function () {
    var existingVideos, gameIdDom, gameId, gameName, videosResp, videosJson, videos, game;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                existingVideos = document.getElementById('game_videos');
                if (!!existingVideos) {
                    return [2 /*return*/];
                }
                gameIdDom = document.getElementById('game_id');
                if (!gameIdDom) {
                    return [2 /*return*/];
                }
                gameId = gameIdDom.value;
                gameName = document.getElementById('game_name').value;
                return [4 /*yield*/, fetchVideos(gameId)];
            case 1:
                videosResp = _a.sent();
                return [4 /*yield*/, videosResp.json()];
            case 2:
                videosJson = _a.sent(), videos = videosJson['items'], game = { "name": gameName };
                if (!videos) {
                    return [2 /*return*/];
                }
                new Vue({
                    el: '#game_videos_placeholder',
                    render: function (h) {
                        return h(VideosList, {
                            props: {
                                videos: videos,
                                game: game
                            }
                        });
                    }
                });
                return [2 /*return*/];
        }
    });
}); });
window.setTimeout(function (e) { return __awaiter(void 0, void 0, void 0, function () {
    var isNeedSearchPlaceholder, withGamesList, withGames, urlParams, queryFilters;
    return __generator(this, function (_a) {
        isNeedSearchPlaceholder = document.getElementById('game_filters_placeholder');
        if (!isNeedSearchPlaceholder) {
            return [2 /*return*/];
        }
        withGamesList = document.getElementById('game_filters_list');
        if (withGamesList) {
            withGames = true;
        }
        urlParams = new URLSearchParams(window.location.search);
        queryFilters = {
            "genre": urlParams.get("genre") || "",
            "platform": urlParams.get("platform") || "",
            "ordering": urlParams.get("ordering") || "-release_date",
            "avg_time_from": urlParams.get("avg_time_from") || "",
            "avg_time_to": urlParams.get("avg_time_to") || "",
        };
        if (isNeedSearchPlaceholder) {
            new Vue({
                el: '#game_filters_placeholder',
                render: function (h) {
                    return h(GamesFilter, {
                        props: {
                            defaultQuery: queryFilters,
                            withGames: withGames,
                        }
                    });
                }
            });
        }
        return [2 /*return*/];
    });
}); }, 1);
